import { AggregationLevelEnum, TimeframeEnum } from 'v2/types';

export const INSIGHTS_HASH = 'insights';
export const INSIGHTS_TEAM_ROUTE = 'team';
export const INSIGHTS_TOP_CREATORS_ROUTE = 'creators';
export const INSIGHTS_TOP_DOCUMENTS_ROUTE = 'documents';
export const MY_INSIGHTS_TOP_DOCUMENTS_ROUTE = 'my_documents';
export const INSIGHTS_TOP_USERS_ROUTE = 'users';
export const AREA_CHART_DATE_FORMAT = 'MMM D';

export const TIMEFRAME_TEXT = {
  [TimeframeEnum.Last7Days]: 'last 7 days',
  [TimeframeEnum.Last30Days]: 'last month',
  [TimeframeEnum.Last90ays]: 'last 3 months',
  [TimeframeEnum.Last365Days]: 'last year'
};

const FILTER_EVENTS = {
  selectedDocumentsFilter: 'selected_documents_filter',
  selectedTimeFilter: 'selected_time_filter',
  selectedTeamFilter: 'selected_team_filter',
  resetFilters: 'reset_insights_filters'
};

export const EVENT_TRACKING_MAP = {
  [AggregationLevelEnum.User]: {
    tabClicked: 'clicked_my_insights',
    stats: {
      ...FILTER_EVENTS,
      location: 'my_insights_stats'
    },
    topDocuments: {
      ...FILTER_EVENTS,
      location: 'my_insights_top_documents'
    },
    documents: {
      ...FILTER_EVENTS,
      location: 'my_top_documents'
    },
    topUsers: {
      ...FILTER_EVENTS,
      location: 'my_insights_top_users'
    },
    users: {
      ...FILTER_EVENTS,
      location: 'my_top_users'
    }
  },
  [AggregationLevelEnum.Team]: {
    tabClicked: 'clicked_team_insights',
    stats: {
      ...FILTER_EVENTS,
      location: 'team_insights_stats'
    },
    topDocuments: {
      ...FILTER_EVENTS,
      location: 'team_insights_top_documents'
    },
    documents: {
      ...FILTER_EVENTS,
      location: 'team_top_documents'
    },
    topUsers: {
      ...FILTER_EVENTS,
      location: 'team_insights_top_creators'
    },
    users: {
      ...FILTER_EVENTS,
      location: 'top_creators'
    }
  },
  [AggregationLevelEnum.Teams]: {
    tabClicked: 'clicked_org_insights',
    stats: {
      ...FILTER_EVENTS,
      location: 'org_insights_stats'
    },
    topDocuments: {
      ...FILTER_EVENTS,
      location: 'org_insights_top_documents'
    },
    topUsers: {
      ...FILTER_EVENTS,
      location: 'org_insights_top_users'
    },
    users: {
      ...FILTER_EVENTS,
      location: 'org_top_users'
    },
    documents: {
      ...FILTER_EVENTS,
      location: 'org_top_documents'
    }
  }
};
